import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { emailSignInStart, googleSignInStart, signInSuccess } from '../../../redux/User/user.actions';
import "../Signup/Signup.css";
import { auth, GoogleProvider } from '../../../firebase/utils';
import { Button, Spinner } from 'react-bootstrap';
import LogoMark from "../../../images/LogoMark.png"
import Header from "../../../components/GreenHeaderLogin/GreenHeaderLogin"

  
const myStyle={
  backgroundImage: `url(${LogoMark})`,
  backgroundColor: '#016b37',
  height:'100vh',
  marginTop:'-10px',
  fontSize:'50px',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
};

const mapState = ({ user }) => ({
  currentUser: user.currentUser
});



const Login = props => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isloading, setLoading] = useState(false);
  const [error, setErrors] = useState("");
  const { currentUser, userErr } = useSelector(mapState);
  const [passtoggle, setPasstoggle] = useState(false);
  const [passtypetoggle, setPasstypetoggle] = useState(false);


  useEffect(() => {
    if (currentUser) {
      resetForm();
      if (auth.currentUser.emailVerified) {
        history.push('/homepage');
      }
      
    }

  }, [currentUser]);

  const resetForm = () => {
    setEmail('');
    setPassword('');
  };

  const handleSubmit = async (e)  => {
    setLoading(true);
    e.preventDefault();
    setErrors("");
   

    auth.fetchSignInMethodsForEmail(email)
      .then((signInMethods) => {
        if (signInMethods.length) {
 
          auth.signInWithEmailAndPassword(email, password)
            .then((userCredential) => {
              const user = userCredential.user;
              if (user.emailVerified) {
                dispatch(emailSignInStart({ email, password }));
              } else {
                setErrors("");
                setLoading(false);
                setTimeout(() => {
                  setErrors('Your email is not verified yet: A verification mail has been sent to your email, kindly check your inbox or spam')
                 
                })
               
              }

            })
            .catch((error) => {
              const errorCode = error.code;
              const errorMessage = error.message;
              setErrors(errorMessage);
              setLoading(false);
              setTimeout(() => {
                console.log("firebase error" + error)
              });
            });

        } 
        else {
          setLoading(false);
          setTimeout(() => {
            setErrors('User does not exist')
          })
        }
      })
      .catch((err) => {
        console.log('firebase error' + err);
        if (err.code === 'auth/network-request-failed') {
          setTimeout(() => {
            setErrors('No internet connection')
          })
          setLoading(false);
        }
      });

  }

  
  const handleGoogleSignIn = () => {
dispatch(googleSignInStart());
// if ()
         
}


  const hidePass = () => {
    setPasstoggle(!passtoggle);
    setPasstypetoggle(!passtypetoggle)
  }


  
// const Google = () =>{

//   auth.signInWithPopup(GoogleProvider)

//   .then((googleSignInStart)=>{
    
//       // console.log(res)
//       setLoading(false);
//       setTimeout(() => {
//         history.push('/homepage');
//       } , 1000);
//       }).catch((err)=>{
//         console.log(err)
//       }
//       )
  
  // var google_provider = new firebase.auth.GoogleAuthProvider();
  // firebase.auth().signInWithPopup(google_provider)
  // .then((res)=>{
  //   console.log(res)

  //   setLoading(false);
  //   setTimeout(() => {
  //     history.push('/homepage');
  //   } , 1000);

  //   }).catch((err)=>{
  //     console.log(err)
  //   }
  //   )
// }


  return (

    <>

        <Header/>

        <div style={myStyle} className="supHeight">

    
        <div className='signUpCont'>

          <h1 className="sUP">
            Log in to the <span>planet</span>
          </h1>

          {error && <div className="error1">{error}</div>} 



        <form className="form" onSubmit={handleSubmit} >
                
        <div className='label2'><p>Email ID*</p></div>
             
             <input type="email" className='signUpEmail' placeholder="Enter your email" onChange={(e) => setEmail(e.target.value)} required />
      
{/* 
           <div className='label2'><p>Password*</p></div>
       
             <input type="password" className="signUpEmail" placeholder="Enter your password" onChange={(e) => setPassword(e.target.value)} required /> */}

              
          <div className='label2'><p>Password*</p></div>

          <div className='passwordFlex'>

          <input
          type={passtypetoggle ? 'text' : 'password'}
          name="password"
          value={password}
          minlength="4"
          placeholder="Enter your Password"
          className='signUpPassword'
          onChange={e => setPassword(e.target.value)}
          />
          <div className='visibility-btn' onClick={hidePass}>
          <div className='toggle-Icn'>

            <i class={passtoggle ? "fa1 fa-eye active" : "fa1 fa-eye" }></i>

            <i class={passtoggle ? "fa1 fa-eye-slash" : "fa1 fa-eye-slash active"}></i>
          </div>
          </div>
          </div>

          <div className='forgot'>
                
          <Link to="/forgotPassword" className="forgotText">Forgot password? Click to recover</Link>
          </div>
      

              <button className="signUpBtn" >
             {isloading ? <Spinner animation="border" role="status" size="sm" variant="primary" /> : <p>Login</p>}
           </button>

{/*                    
            <div id="oR">OR</div> */}

            <div>
              <div id="cWG">
                <button onClick={handleGoogleSignIn}>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.8249 7.23735H17.1V7.2H9V10.8H14.0864C13.3443 12.8956 11.3503 14.4 9 14.4C6.01785 14.4 3.6 11.9822 3.6 9C3.6 6.01785 6.01785 3.6 9 3.6C10.3765 3.6 11.6289 4.1193 12.5824 4.96755L15.1281 2.4219C13.5207 0.92385 11.3706 0 9 0C4.02975 0 0 4.02975 0 9C0 13.9703 4.02975 18 9 18C13.9703 18 18 13.9703 18 9C18 8.39655 17.9379 7.8075 17.8249 7.23735Z"
                      fill="#FFC107"
                    />
                    <path
                      d="M1.0376 4.81095L3.99455 6.9795C4.79465 4.9986 6.73235 3.6 8.9999 3.6C10.3764 3.6 11.6288 4.1193 12.5823 4.96755L15.128 2.4219C13.5206 0.92385 11.3705 0 8.9999 0C5.543 0 2.5451 1.95165 1.0376 4.81095Z"
                      fill="#FF3D00"
                />
                <path
                  d="M9.00004 17.9999C11.3247 17.9999 13.437 17.1103 15.0341 15.6635L12.2486 13.3064C11.3146 14.0167 10.1734 14.4008 9.00004 14.3999C6.65914 14.3999 4.67149 12.9073 3.92269 10.8242L0.987793 13.0855C2.47729 16.0001 5.50219 17.9999 9.00004 17.9999Z"
                  fill="#4CAF50"
                />
                <path
                  d="M17.825 7.2373H17.1V7.19995H9V10.8H14.0864C13.7314 11.7973 13.092 12.6689 12.2472 13.3069L12.2485 13.306L15.034 15.6631C14.8369 15.8422 18 13.5 18 8.99995C18 8.3965 17.9379 7.80745 17.825 7.2373Z"
                  fill="#1976D2"
                />
              </svg>

              <span> Continue with google </span>
              
            </button>
          </div>
        </div>

        {/* <div id="line-1"></div> */}

        {/* <div id="signUptxt">
          By continuing, you agree to Digital Planet’s Terms of Use and
          confirm that you have read <br /> Digital Planet’s Privacy Policy
        </div> */}
                    

          </form>


</div>

</div>


    </>


  );
}

export default Login;
